/** Push custom events to GTM dataLayer (configured in GTM-KF8V4NB2). */
export function pushGtmEvent({ category, action, label }) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "custom_event",
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  });
}

export function pushGtmPageView({ page, title }) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_path: page,
    page_title: title,
  });
}
